<template>
  <div class="fm-content">
    <!-- 瀑布流容器 -->
    <div
      class="waterfall-container"
      ref="container"
      :class="{ 'global-blur': isGlobalBlur }"
    >
      <!-- 动态列 -->
      <div
        v-for="(column, index) in columns"
        :key="'col-' + index"
        class="waterfall-column"
        :style="{ width: columnWidth + 'px' }"
      >
        <div
          v-for="item in column"
          :key="item._uid"
          class="Box"
          @click="goDetail(item)"
          :data-index="item.originalIndex"
          :class="{ visible: item.visible, 'removing-item': item.removing }"
          ref="items"
        >
          <div class="content">
            <div class="BoxTwo">
              <!-- 图片容器 -->
              <div
                :class="{
                  'img-container': true,
                  // isNone: item.imageError || item.cover_is_error == 1,
                }"
                :style="{
                  height: item.cover_height
                    ? `${item.cover_height}px`
                    : '276px',
                }"
              >
                <!-- 模糊占位符 -->
                <div
                  class="blur-placeholder"
                  :class="{ 'fade-out': item.isLoaded || item.imageError }"
                  :style="item.blurStyle"
                >
                  <img :src="item.thumb" alt="" class="placeholder-img" />
                </div>

                <!-- 高质量最终图 -->
                <div
                  class="image-container"
                  :style="{ opacity: item.isLoaded ? 1 : 0 }"
                >
                  <el-image
                    :src="item.cover"
                    :fit="'cover'"
                    class="img"
                    lazy
                    @load="handleImageLoad(item)"
                    @error="handleImageError(item)"
                  ></el-image>
                </div>

                <!-- 加载失败 -->
                <div
                  class="load-fail"
                  :style="{
                    height: item.cover_height + 'px',
                  }"
                  v-show="item.imageError || item.cover_is_error == 1"
                >
                  <svg-btn
                    v-if="item.imageError"
                    class="failIcon"
                    :icon-class="
                      item.stype == 2
                        ? 'icon-gfans-videoNo'
                        : 'icon-gfans-imgNo'
                    "
                  />
                  <svg-btn
                    v-if="item.cover_is_error == 1"
                    class="failIcon"
                    :icon-class="
                      item.stype == 2
                        ? 'icon-gfans-videoWg'
                        : 'icon-gfans-imgWg'
                    "
                  />
                </div>

                <!-- 悬浮遮罩层 -->
                <div class="hover-overlay"></div>
              </div>
              <!-- 更新标识符 -->
              <div class="upBox" v-show="item.is_up == 1 && item.visible">
                更新
              </div>
              <!-- 视频按钮 -->
              <div class="vdBox" v-show="item.type == 0 && item.visible">
                <svg-btn class="vdIcon" icon-class="icon-gfans-vd"></svg-btn>
              </div>
              <!-- 收藏按钮 -->
              <div
                class="collBox"
                @click.stop="cancelUp(item)"
                v-show="item.visible"
              >
                <svg-btn
                  class="coIcon"
                  :icon-class="
                    item.is_collect ? 'icon-gfans-cvda' : 'icon-gfans-cvd'
                  "
                ></svg-btn>
              </div>
            </div>

            <div class="BoxThree">
              {{ item.name }}
            </div>

            <div
              class="BoxFour"
              v-if="item.file_attachment && item.file_attachment.length > 0"
            >
              <div
                class="four"
                v-for="(itn, idx) in item.file_attachment"
                :key="idx"
              >
                <div class="fourLeft">
                  <svg-btn
                    class="btIcon"
                    :icon-class="
                      itn.stype == 1
                        ? 'icon-gfans-wj'
                        : itn.stype == 2
                        ? 'icon-gfans-hj'
                        : 'icon-gfans-fj'
                    "
                  ></svg-btn>
                  <div class="fourFont">{{ itn.name }}</div>
                </div>
              </div>
            </div>
            <div class="BoxFive" v-show="item.visible">
              <div class="leftI" @click.stop="toUser(item)">
                <el-image :src="item.logo" fit="cover" class="logo">
                  <img
                    width="20"
                    height="20"
                    slot="error"
                    class="error-headImg"
                    :src="$utils.getPng('icon-gfans-defaultHead')"
                  />
                </el-image>
                <div class="name">{{ item.nickname }}</div>
              </div>
              <div class="timeC">{{ item.in_time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载更多触发元素 -->
    <div ref="loadMoreTrigger" class="load-more-trigger"></div>

    <!-- 底部加载状态 -->
    <div class="loadStatus" v-if="arrList.length">
      <div v-if="isLoading" id="loadBoxId" class="loadBox">
        <div class="spinner"></div>
        <span class="not">加载中</span>
      </div>
      <div class="not" v-show="noMoreData">没有更多了</div>
    </div>
    <PromptTip
      @confirm="confirm"
      @handleClose="handleClose"
      tips="确定取消收藏该帖子？"
      :isShow="isShow"
    />
  </div>
</template>

<script>
import { checkCollec } from '@/axios/home'
import { eventBus } from '@/utils/event-bus'
import PromptTip from '@/components/PromptTip/index'
import _ from 'lodash'

export default {
  components: {
    PromptTip,
  },
  props: {
    arrList: { type: Array, required: true },
    isLoading: {
      type: Boolean,
      default: false,
    },
    noMoreData: {
      type: Boolean,
      default: false,
    },
    isFind: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: false,
      stype: '',
      file_id: '',
      visibilityObserver: null,
      loadMoreObserver: null,
      imageObserver: null,
      resizeObserver: null,
      containerResizeObserver: null,
      loadMoreDistance: 300,
      imagePreloadDistance: 1000,
      columnWidth: 276, // 默认列宽
      columns: [[], []], // 两列数据
      columnHeights: [0, 0], // 记录每列当前高度
      gap: 16, // 列之间的间隙
      columnCount: 2, // 默认列数
      isMobile: false, // 是否移动端
      initialized: false, // 是否已初始化
      isGlobalBlur: false, // 新增：全局模糊状态
    }
  },
  watch: {
    arrList: {
      immediate: true,
      deep: true,
      handler(newList, oldList) {
        // 处理初始值未定义的情况
        if (
          !this.initialized ||
          !oldList ||
          newList.length !== oldList.length
        ) {
          this.resetLayout()
          this.initialized = true
        }
      },
    },
  },
  mounted() {
    this.checkMobileMode()
    window.addEventListener('resize', this.handleResize)

    this.setupObservers()

    // 确保在 DOM 更新后计算列宽
    this.$nextTick(() => {
      this.calculateColumnWidth()
      this.resetLayout()
    })
  },
  beforeUnmount() {
    this.cleanupObservers()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 检查移动端模式
    checkMobileMode() {
      this.isMobile = window.innerWidth < 576
      this.columnCount = this.isMobile ? 1 : 2
    },

    // 清理所有观察器
    cleanupObservers() {
      this.visibilityObserver?.disconnect()
      this.loadMoreObserver?.disconnect()
      this.imageObserver?.disconnect()
      this.resizeObserver?.disconnect()
      this.containerResizeObserver?.disconnect()
    },

    // 设置观察器
    setupObservers() {
      this.setupLoadMoreObserver()

      // 项目高度变化观察器
      this.resizeObserver = new ResizeObserver(
        _.debounce(entries => {
          this.recalculateColumnHeights()
        }, 100)
      )

      // 容器尺寸变化观察器
      this.containerResizeObserver = new ResizeObserver(
        _.debounce(entries => {
          this.checkMobileMode()
          this.calculateColumnWidth()
          this.resetLayout()
        }, 300)
      )

      // 开始观察容器
      if (this.$refs.container) {
        this.containerResizeObserver.observe(this.$refs.container)
      }
    },

    // 点击收藏
    cancelUp: _.debounce(
      function (item) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        if (item.is_collect == 1) {
          this.stype = item.stype
          this.file_id = item.file_id
          this.isShow = true
          return
        }
        checkCollec({
          type: item.stype,
          is_collect: 1,
          post_id: item.file_id,
        }).then(res => {
          if (res.status == 1) {
            //给该数组的is_collect变更状态
            this.$emit('remove-item', {
              file_id: item.file_id,
              stype: item.stype,
            })
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 取消收藏弹出确认按钮
    confirm: _.debounce(
      function () {
        checkCollec({
          type: this.stype,
          is_collect: 0,
          post_id: this.file_id,
        }).then(res => {
          if (res.status == 1) {
            if (this.$route.name == 'collect') {
              // 1. 开启全局模糊
              this.isGlobalBlur = true
              // 标记项目为正在移除状态
              const item = this.arrList.find(
                i => i.file_id === this.file_id && i.stype === this.stype
              )

              if (item) {
                this.$set(item, 'removing', true)
                // 3. 强制重新布局 - 关键点1
                this.$nextTick(() => {
                  // 触发浏览器重排
                  void this.$refs.container.offsetHeight

                  // 优化布局计算 - 关键点2
                  this.optimizedResetLayout()
                })
                // 添加模糊效果
                this.$emit('remove-item', {
                  file_id: this.file_id,
                  stype: this.stype,
                })
                setTimeout(() => {
                  this.isGlobalBlur = false
                }, 300)
              }
            } else {
              //给该数组的is_collect变更状态
              this.$emit('remove-item', {
                file_id: this.file_id,
                stype: this.stype,
              })
            }
            this.handleClose()
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),
    // 新增：优化布局重置方法
    optimizedResetLayout() {
      // 只更新受影响的列
      let updated = false

      // 查找被移除项目所在的列
      for (let colIndex = 0; colIndex < this.columns.length; colIndex++) {
        const index = this.columns[colIndex].findIndex(
          item =>
            item.removing &&
            item.file_id === this.file_id &&
            item.stype === this.stype
        )

        if (index !== -1) {
          // 1. 临时移除该项目
          this.columns[colIndex].splice(index, 1)

          // 2. 重新计算该列高度
          this.recalculateSingleColumnHeight(colIndex)

          // 3. 标记已更新
          updated = true
          break
        }
      }

      // 如果未找到，回退到全量重置
      if (!updated) {
        this.resetLayout()
      }
    },

    // 新增：重新计算单列高度
    recalculateSingleColumnHeight(colIndex) {
      let totalHeight = 0
      const columnElements = this.$refs.items?.filter(el => {
        const colEl = el.closest('.waterfall-column')
        return (
          colEl &&
          Array.from(this.$refs.container.children).indexOf(colEl) === colIndex
        )
      })

      if (columnElements && columnElements.length > 0) {
        columnElements.forEach(el => {
          totalHeight += el.offsetHeight + this.gap
        })
        // 减去最后一个元素的间隙
        totalHeight -= this.gap
        this.columnHeights[colIndex] = totalHeight
      }
    },

    // 关闭取消订阅弹窗
    handleClose() {
      this.stype = ''
      this.file_id = ''
      this.isShow = false
    },

    // 计算列宽
    calculateColumnWidth() {
      const container = this.$refs.container
      if (!container || container.offsetWidth === 0) {
        // 如果容器尚未渲染或宽度为0，使用默认值
        this.columnWidth = 276
        return
      }

      const containerWidth = container.offsetWidth
      // 计算每列宽度
      this.columnWidth =
        (containerWidth - (this.columnCount - 1) * this.gap) / this.columnCount
    },

    // 重置布局 - 完全按照列高来动态分配
    // resetLayout() {
    //   // 更新列结构
    //   this.columns = Array.from({ length: this.columnCount }, () => [])
    //   this.columnHeights = Array(this.columnCount).fill(0)

    //   // 1. 先按顺序分配项目，确保每列都有基础项目
    //   const baseItemsPerColumn = Math.min(
    //     3,
    //     Math.ceil(this.arrList.length / this.columnCount)
    //   )

    //   for (let col = 0; col < this.columnCount; col++) {
    //     for (let i = 0; i < baseItemsPerColumn; i++) {
    //       const index = col * baseItemsPerColumn + i
    //       if (index < this.arrList.length) {
    //         this.columns[col].push(this.arrList[index])
    //       }
    //     }
    //   }

    //   // 2. 剩余项目根据列高度智能分配
    //   for (
    //     let i = baseItemsPerColumn * this.columnCount;
    //     i < this.arrList.length;
    //     i++
    //   ) {
    //     const item = this.arrList[i]

    //     // 使用预估高度进行分配
    //     const estimatedHeight = this.estimateItemHeight(item)
    //     const minHeight = Math.min(...this.columnHeights)
    //     const columnIndex = this.columnHeights.indexOf(minHeight)

    //     this.columns[columnIndex].push(item)
    //     this.columnHeights[columnIndex] += estimatedHeight + this.gap
    //   }

    //   // 设置可见性观察器
    //   this.$nextTick(() => {
    //     this.setupVisibilityObserver()
    //     this.setupImagePreloadObserver()
    //     this.observeItems()
    //   })
    // },
    // 重置布局 - 修改为交替排序
    // resetLayout() {
    //   // 更新列结构
    //   this.columns = Array.from({ length: this.columnCount }, () => [])
    //   this.columnHeights = Array(this.columnCount).fill(0)

    //   // 完全按顺序交替分配项目
    //   for (let i = 0; i < this.arrList.length; i++) {
    //     const columnIndex = i % this.columnCount;
    //     const item = this.arrList[i];

    //     this.columns[columnIndex].push(item);

    //     // 更新列高度（预估）
    //     this.columnHeights[columnIndex] += this.estimateItemHeight(item) + this.gap;
    //   }

    //   // 每列减去最后一个项目的间隙
    //   this.columnHeights = this.columnHeights.map(height => Math.max(0, height - this.gap));

    //   // 设置可见性观察器
    //   this.$nextTick(() => {
    //     this.setupVisibilityObserver()
    //     this.setupImagePreloadObserver()
    //     this.observeItems()
    //   })
    // },
    // 重置布局 - 交替排序的同时考虑高度平不平衡
    resetLayout() {
      // 更新列结构
      this.columns = Array.from({ length: this.columnCount }, () => [])
      this.columnHeights = Array(this.columnCount).fill(0)

      // 创建列高度的副本用于排序
      const tempColumnHeights = [...this.columnHeights]

      // 交替分配项目，但考虑高度平衡
      for (let i = 0; i < this.arrList.length; i++) {
        const item = this.arrList[i]
        const estimatedHeight = this.estimateItemHeight(item)

        // 确定当前应该分配到哪一列（交替顺序）
        const baseColumnIndex = i % this.columnCount

        // 检查分配到基列后是否会导致高度不平衡
        const baseColumnHeightAfter =
          tempColumnHeights[baseColumnIndex] + estimatedHeight

        // 查找高度最小的列
        const minHeight = Math.min(...tempColumnHeights)
        const minHeightColumnIndex = tempColumnHeights.indexOf(minHeight)

        // 如果分配到基列不会导致高度不平衡（在阈值内），使用基列
        // 否则分配到高度最小的列
        const columnIndex =
          baseColumnHeightAfter - minHeight <= 300
            ? baseColumnIndex
            : minHeightColumnIndex

        // 添加到选定的列
        this.columns[columnIndex].push(item)
        tempColumnHeights[columnIndex] += estimatedHeight + this.gap
      }

      // 更新实际列高度
      this.columnHeights = tempColumnHeights.map(height =>
        Math.max(0, height - this.gap)
      )

      // 设置可见性观察器
      this.$nextTick(() => {
        this.setupVisibilityObserver()
        this.setupImagePreloadObserver()
        this.observeItems()
      })
    },
    // 预估项目高度 - 关键优化点
    estimateItemHeight(item) {
      // 基础高度（标题、作者信息等）
      let height = 120

      // 图片/视频高度
      if (item.cover_height) {
        height += item.cover_height
      } else if (item.type === 0) {
        // 视频
        height += 240
      } else {
        // 图片
        height += 180
      }

      // 附件区域高度
      if (item.file_attachment && item.file_attachment.length > 0) {
        height += item.file_attachment.length * 40
      }
      return height
    },
    // 将项目添加到最短列
    addToColumn(item) {
      // 如果是单列模式，直接添加到第一列
      if (this.columnCount === 1) {
        this.columns[0].push(item)
        return
      }

      // 找到当前最短列的索引
      const minHeight = Math.min(...this.columnHeights)
      const columnIndex = this.columnHeights.indexOf(minHeight)

      // 添加到该列
      this.columns[columnIndex].push(item)
    },

    // 观察项目高度变化
    observeItems() {
      if (!this.$refs.items || !this.$refs.items.length) return

      // 清除旧的观察器
      this.resizeObserver?.disconnect()

      // 重新创建观察器
      this.resizeObserver = new ResizeObserver(
        _.debounce(entries => {
          this.recalculateColumnHeights()
        }, 100)
      )

      // 观察所有项目
      this.$refs.items.forEach(item => {
        this.resizeObserver.observe(item)
      })
    },

    // 重新计算所有列的高度 - 关键优化点
    recalculateColumnHeights() {
      // 重置列高度
      this.columnHeights = Array(this.columnCount).fill(0)

      // 遍历所有列
      this.columns.forEach((column, colIndex) => {
        // 遍历当前列的所有项目
        column.forEach(item => {
          // 查找对应的DOM元素
          const itemEl = this.$refs.items?.find(el => {
            const index = parseInt(el.dataset.index)
            return index === item.originalIndex
          })

          // 如果找到元素，累加高度
          if (itemEl) {
            // 添加间隙高度
            this.columnHeights[colIndex] += itemEl.offsetHeight
          }
          // 如果元素尚未渲染，使用预估高度
          else {
            this.columnHeights[colIndex] +=
              this.estimateItemHeight(item) + this.gap
          }
        })
      })
    },

    // 处理窗口大小变化
    handleResize: _.debounce(function () {
      this.checkMobileMode()
      this.calculateColumnWidth()
      this.resetLayout()
    }, 300),

    // 图片加载成功处理 - 关键优化点
    handleImageLoad(item) {
      // 计算并保存图片实际高度
      const img = new Image()
      img.onload = () => {
        const aspectRatio = img.height / img.width
        const newHeight = Math.round(this.columnWidth * aspectRatio)
        //注释这一行因为此高度公式已经告知后端，由后端计算，避免渲染时高度由变化
        // this.$set(item, 'cover_height', newHeight)

        // 触发父组件事件
        this.$emit('image-loaded', {
          originalIndex: item.originalIndex,
          isLoaded: true,
        })

        // 重新计算列高度
        this.$nextTick(() => {
          this.recalculateColumnHeights()
        })
      }
      img.src = item.cover
    },

    // 图片加载失败处理
    handleImageError(item) {
      this.$emit('image-error', {
        originalIndex: item.originalIndex,
        imageError: true,
      })
    },

    // 设置可见性观察器
    setupVisibilityObserver() {
      if (!('IntersectionObserver' in window)) return

      this.visibilityObserver?.disconnect()

      const elements = Array.from(
        this.$el.querySelectorAll('.Box:not(.visible)')
      )
      if (elements.length === 0) return

      this.visibilityObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const originalIndex = parseInt(entry.target.dataset.index)
              const item = this.arrList.find(
                item => item.originalIndex === originalIndex
              )
              if (item && !item.visible) {
                this.$set(item, 'visible', true)
                this.preloadImage(item.cover)
                this.visibilityObserver.unobserve(entry.target)
              }
            }
          })
        },
        { rootMargin: '0px 0px 1500px 0px', threshold: 0.01 }
      )

      elements.forEach(el => {
        this.visibilityObserver.observe(el)
      })
    },

    // 设置图片预加载观察器
    setupImagePreloadObserver() {
      if (!('IntersectionObserver' in window)) return

      this.$nextTick(() => {
        this.imageObserver?.disconnect()

        const containers = Array.from(
          this.$el.querySelectorAll('.img-container')
        )
        if (containers.length === 0) return

        this.imageObserver = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              const originalIndex = parseInt(
                entry.target.closest('.Box').dataset.index
              )
              const item = this.arrList.find(
                item => item.originalIndex === originalIndex
              )
              if (item && entry.isIntersecting && !item.isLoaded) {
                this.preloadImage(item.cover)
                this.imageObserver.unobserve(entry.target)
              }
            })
          },
          { rootMargin: `0px 0px 2000px 0px` }
        )

        containers.forEach(container => {
          this.imageObserver.observe(container)
        })
      })
    },

    // 预加载图片
    preloadImage(url) {
      if (!url) return
      const img = new Image()
      img.src = url
    },

    // 设置加载更多观察器
    setupLoadMoreObserver() {
      if (!('IntersectionObserver' in window)) return

      const trigger = this.$refs.loadMoreTrigger
      if (!trigger) return

      this.loadMoreObserver?.disconnect()

      this.loadMoreObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !this.noMoreData && !this.isLoading) {
            this.$emit('load-more')
          }
        },
        { rootMargin: `0px 0px ${this.loadMoreDistance}px 0px` }
      )

      this.loadMoreObserver.observe(trigger)
    },
    //跳转个人中心
    toUser: _.debounce(
      function (item) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        const route = this.$router.resolve({
          name: 'user',
          params: { uid: item.userid },
        })
        // 使用解析后的 href 打开新窗口
        window.open(route.href, '_blank')
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    goDetail(item) {
      item.is_up = 0
      const routeName = item.stype == 1 ? 'jx' : 'vd'
      const route = this.$router.resolve({
        name: routeName,
        params: { id: item.fshort },
      })
      window.open(route.href, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.fm-content {
  padding: 0 16px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  position: sticky;
  top: 146px;
  @include useTheme {
    background: getVar('bg-color-content');
  }
}
/* 新增全局模糊样式 */
.global-blur {
  .Box .img-container .image-container,
  .Box .img-container .blur-placeholder {
    filter: blur(15px);
    transition: filter 0.3s ease;
  }
}
/* 瀑布流容器样式 */
.waterfall-container {
  display: flex;
  gap: 16px;
  transition: height 0.4s ease;
}

.waterfall-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: transform 0.4s ease;
}

.Box {
  cursor: pointer;
  padding: 0;
  box-shadow: none;
  opacity: 0;
  transform: translateY(20px);
  will-change: opacity, transform;
  transition: all 0.3s ease;
  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
  &.removing-item {
    transition: all 0.3s ease, transform 0.4s ease, opacity 0.3s ease !important;
    pointer-events: none;
  }
  .content {
    border-radius: 16px;
    overflow: hidden;
    @include useTheme {
      background: getVar('bg-color-content');
    }

    .BoxTwo {
      position: relative;
      border-radius: 16px;
      .img-container {
        position: relative;
        overflow: hidden;
        border-radius: 16px;
        width: 100%;

        .blur-placeholder {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          border-radius: 16px;
          @include useTheme {
            background: getVar('bg-color-content');
          }
          .placeholder-img {
            width: 100%;
            height: 100%;
            filter: blur(15px);
            object-fit: cover;
            border-radius: 16px;
          }

          &.fade-out {
            opacity: 0;
            pointer-events: none;
          }
        }

        .image-container {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border-radius: 16px;
        }

        .img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border-radius: 16px;
        }

        .load-fail {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          width: 100%;
          z-index: 3;
          @include useTheme {
            background: getVar('bg-color10-f4f6f8');
          }
          .failIcon {
            width: 64px;
            height: 64px;
          }
        }

        .hover-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0);
          z-index: 5;
          pointer-events: none;
          transition: background-color 0.3s ease;
          border-radius: 16px;
        }

        &:hover .hover-overlay {
          background-color: rgba(0, 0, 0, 0.3);
        }
      }
      .vdBox {
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translate(50%, -50%);
        z-index: 200;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        backdrop-filter: blur(10px);
        background: rgba(64, 64, 64, 0.25);
        display: flex;
        align-items: center;
        justify-content: center;
        .vdIcon {
          width: 28px;
          height: 28px;
        }
      }
      .upBox {
        position: absolute;
        top: 12px;
        left: 12px;
        z-index: 200;
        width: 36px;
        height: 18px;
        font-weight: 400;
        font-size: 12px;
        border-radius: 4px;
        color: #ffffff;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        @include useTheme {
          background: getVar('primary-color');
        }
      }
      .collBox {
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 200;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        backdrop-filter: blur(10px);
        background: rgba(64, 64, 64, 0.25);
        display: none;
        align-items: center;
        justify-content: center;
        .coIcon {
          width: 16px;
          height: 16px;
        }
        &:hover {
          background: rgba(250, 252, 253, 0.3);
        }
      }

      // 当BoxTwo被悬停时，显示collBox
      &:hover .collBox {
        display: flex;
      }

      // 当BoxTwo被悬停时，同时显示collBox和hover-overlay
      &:hover .img-container .hover-overlay {
        background-color: rgba(0, 0, 0, 0.3);
      }

      // 当collBox被悬停时，也显示hover-overlay
      .collBox:hover + .img-container .hover-overlay,
      .collBox:hover ~ .img-container .hover-overlay {
        background-color: rgba(0, 0, 0, 0.3);
      }

      .isNone {
        width: 100%;
        // height: 176px !important;
      }
    }

    .BoxThree {
      margin: 8px 8px 12px 8px;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      @include multiline(2);
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }

    .BoxFour {
      margin: 0 8px 8px 8px;
      border-radius: 8px;
      @include useTheme {
        border: 1px solid getVar('border-color2-f2f4f6');
      }
      .four {
        padding: 8px 7px;
        display: flex;
        height: 32px;
        align-items: center;
        justify-content: space-between;
        @include useTheme {
          box-shadow: inset 0px -1px 0px 0px getVar('border-color2-f2f4f6');
        }
        &:last-child {
          box-shadow: none !important;
        }
        .fourLeft {
          display: flex;
          align-items: center;
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
          .btIcon {
            width: 16px;
            height: 16px;
          }
          .fourFont {
            margin-left: 4px;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            @include multiline(1);
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
        }
      }
    }
    .BoxFive {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px;
      .leftI {
        display: flex;
        .logo {
          width: 20px;
          height: 20px;
          object-fit: cover;
          border-radius: 50%;
        }
        .name {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          margin-left: 6px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .timeC {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        margin-left: 5px;
        white-space: nowrap;
        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
    }
  }
}

.load-more-trigger {
  height: 1px;
  margin-top: 16px;
}
.loadStatus {
  padding: 32px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .loadBox {
    display: flex;
    align-items: center;
    .spinner {
      border: 3px solid rgba(5, 216, 196, 0.2);
      border-radius: 50%;
      width: 18px;
      height: 18px;
      animation: spin 1s linear infinite;
      margin-right: 10px;
      @include useTheme {
        border-top: 3px solid getVar('primary-color');
      }
    }
  }
  .not {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    @include useTheme {
      color: getVar('text-color6-b8bec4');
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 576px) {
  .waterfall-container {
    flex-direction: column;
    gap: 0;

    .waterfall-column {
      gap: 16px;
      width: 100% !important;
    }
  }
}
</style>
